import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from 'react-query';
import ApiService from '../../_shared/api/apiService';
import { FEATURE_FLAG } from '../../_shared/constants/queryDefinition';

const propTypes = {
  component: PropTypes.func.isRequired
};

const UnauthenticatedRoute = ({ component: Component }) => {
  const queryClient = useQueryClient();
  const [isApiLoaded, setApiLoaded] = useState(false);

  useEffect(() => {
    async function fetchApi() {
      const client = await ApiService();
      if (client) {
        setApiLoaded(true);
      }
    }

    fetchApi();
  }, []);

  useEffect(() => {
    if (isApiLoaded) {
      queryClient.invalidateQueries(FEATURE_FLAG.KEY);
    }
  }, [isApiLoaded, queryClient]);

  return isApiLoaded ? <Component /> : null;
};

UnauthenticatedRoute.propTypes = propTypes;

export default UnauthenticatedRoute;
